import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const formStrings = new LocalizedStrings({
  en: {
    optional: 'Optional',
    pleaseSelect: 'Please select'
  }
});

export default withCommon<typeof formStrings>(formStrings);
